import { render, staticRenderFns } from "./MailMessage.vue?vue&type=template&id=3aae4cfd"
import script from "./MailMessage.vue?vue&type=script&lang=js"
export * from "./MailMessage.vue?vue&type=script&lang=js"
import style0 from "./MailMessage.vue?vue&type=style&index=0&id=3aae4cfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports